import "./kendo.core.js";
import "./kendo.fx.js";
import "./kendo.data.odata.js";
import "./kendo.data.xml.js";
import "./kendo.data.js";
import "./kendo.data.signalr.js";
import "./kendo.binder.js";
import "./kendo.validator.js";
import "./kendo.router.js";
import "./kendo.view.js";
import "./kendo.userevents.js";
import "./kendo.draganddrop.js";
import "./kendo.popup.js";
import "./kendo.touch.js";
import "./kendo.mobile.scroller.js";
    "bundle all";
export default kendo;
